import axios from 'axios'
import Vue from 'vue'

axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, async (error) => {
  Vue.$toast.error(`${error.response?.data?.message || ' '}`, {
    timeout: 10000
  });
  return Promise.reject(error);
});


Vue.prototype.$axios = axios